import client from './client';

export interface SettingsPayload {
  session_id: string;
  settings: {
    session_duration?: string;
    theme?: string;
  };
}

export async function saveSettings(payload: SettingsPayload): Promise<void> {
  await client.post('/settings', payload);
}
